// Module
var code = " <h2> Week 5 in class work </h2> <p>Turn in your in-class work from week 5.</p> <p>As before, tell me what you did. How it went. </p> <p>Include screenshots to show what you made. You can include some code snippets. </p> ";
// Exports
export default code;